export default __webpack_public_path__ + "21e1f401aa27ce3660b8fe64f9d1ca6b.svg";